<div class="datatable-search">
  <button
    class="datatable-search__button"
    mat-icon-button
    matTooltip="Search"
    (click)="onClick()"
    [color]="showSearch() ? 'accent' : 'primary'"
  >
    <mat-icon
      [matBadge]="!showSearch() && search() ? '...' : ''"
      matBadgeColor="accent"
      aria-hidden="false"
    >
      search
    </mat-icon>
  </button>
  <div class="datatable-search__container">
    @if (showSearch()) {
      <mat-form-field
        class="datatable-search__input small-form-field small-icon-button-wrapper"
        appearance="outline"
        [ngClass]="{ wide: false }"
      >
        <mat-label>Search</mat-label>
        <input #searchInput matInput [(ngModel)]="search" />
        @if (search()) {
          <button
            class="datatable-search__close-button"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="onReset()"
          >
            <mat-icon>close</mat-icon>
          </button>
        }
      </mat-form-field>
    }
  </div>
</div>
